var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyFilter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 880,
    height: 635,
    viewBox: "0 0 880 635",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3F3D56",
    d: "M763.768 309.116H771.5980000000001V618.1379999999999H763.768z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BEBEBE",
    d: "M843.856 348.497c.498 108.057-75.587 196.007-75.587 196.007s-76.893-87.245-77.392-195.303c-.498-108.057 75.587-196.007 75.587-196.007s76.893 87.246 77.392 195.303z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3F3D56",
    d: "M611.018 454.515H615.0450000000001V613.452H611.018z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BEBEBE",
    d: "M652.209 474.77c.256 55.576-38.876 100.81-38.876 100.81s-39.548-44.872-39.804-100.448c-.257-55.576 38.876-100.811 38.876-100.811s39.548 44.872 39.804 100.449z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 694.418,
    cy: 617.904,
    fill: "#6369D1",
    rx: 109.104,
    ry: 16.711
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M703.417 228.442c-9.244-15.606-27.531-16.334-27.531-16.334s-17.82-2.277-29.252 21.492c-10.655 22.154-25.36 43.544-2.367 48.73l4.153-12.916 2.572 13.878c3.274.235 6.558.291 9.838.168 24.624-.795 48.074.232 47.319-8.597-1.004-11.737 4.162-31.405-4.732-46.421z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBBEBE",
    d: "M670.129 257.832s11.946 16.71 4.778 30.238c-7.167 13.527 16.724 27.85 16.724 27.85l17.52-38.195s-20.705-13.528-15.13-26.26l-23.892 6.367z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 678.093,
    cy: 244.304,
    fill: "#FBBEBE",
    rx: 20.706,
    ry: 20.689
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBBEBE",
    d: "M606.435 268.22l17.304-22.307s6.092-23.383 14.917-22.197c8.824 1.185-3.486 28.041-3.486 28.041l-17.193 24.693-11.542-8.23zM694.021 564.987L699.595 594.429 711.541 597.612 708.355 562.6zM814.274 533.157L835.776 562.6 844.536 566.578 851.704 554.642 830.202 526.791z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6369D1",
    d: "M689.242 303.189l-13.285-17.474s-25.738 4.742-28.127 7.13c-2.389 2.386 6.371 46.152 6.371 46.152s1.593 11.936 8.76 18.302l7.168 4.774 58.932-11.936 2.216-26.2c1.632-19.297-4.956-38.387-18.144-52.578l-10.254 1.4-13.637 30.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6369D1",
    d: "M651.016 294.436l-3.982-1.592-18.317-1.591s-6.37-1.592-4.778-4.775c1.593-3.183 3.185-3.979 0-4.774-3.186-.796-3.982-1.592-3.186-3.979.797-2.387 5.575-7.162 5.575-7.162l-13.539-11.14s-.732.518-1.917 1.476c-6.721 5.438-27.99 25.057-12.417 44.677 18.316 23.076 39.819 36.604 57.339 31.83l-4.778-42.97z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3F3D56",
    d: "M668.536 358.095v11.14s-7.167 13.528-4.778 26.26c2.389 12.731 3.185 19.097 3.185 19.097.26 10.828 2.14 21.557 5.575 31.83 5.575 15.915-12.742 120.156 10.353 121.748 23.095 1.591 35.837 3.183 43.004-4.775 7.168-7.957-11.945-144.824-11.945-144.824s65.303 136.071 78.841 130.501c13.539-5.57 47.783-18.302 43.801-25.464C832.59 516.447 732.247 357.3 732.247 357.3l-3.186-7.162-60.525 7.958z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2F2E41",
    d: "M706.762 588.86s-12.742-.797-12.742 3.182-6.37 17.506-6.37 17.506-4.78 15.915 7.963 14.324c12.742-1.592 20.706-15.915 20.706-15.915l-3.186-15.12-6.37-3.978zM839.758 561.008s-11.15-7.161-10.353-2.387c.796 4.774 1.593 17.506 7.167 18.302 5.575.796 22.299 5.57 23.095 7.162.797 1.591 19.91 7.957 19.91-2.388 0-10.344-11.946-18.302-11.946-18.302l-13.538-10.344s-8.76-.796-10.353 4.774-3.982 3.183-3.982 3.183z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 678.124,
    cy: 212.187,
    fill: "#000",
    rx: 13.223,
    ry: 13.212
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M663.51 208.71c0-6.758 5.104-12.426 11.83-13.137-.462-.05-.927-.074-1.392-.075-7.302 0-13.222 5.916-13.222 13.213 0 7.296 5.92 13.212 13.222 13.212.465 0 .93-.026 1.392-.074-6.726-.712-11.83-6.38-11.83-13.138z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M699.33 226.938L681.263 217.481 656.313 221.35 651.151 244.13 664.001 243.636 667.591 235.268 667.591 243.499 673.52 243.271 676.961 229.946 679.112 244.13 700.191 243.701z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBBEBE",
    d: "M698.248 359.938l-27.863.753s-23.775 4.622-22.44-4.966c1.333-9.589 24.527-6.235 24.527-6.235l25.389-3.87.387 14.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6369D1",
    d: "M720.294 270.01c2.893-.437 5.675 1.293 6.559 4.08 5.454 17.176 22.26 74.652 5.563 82.537-19.666 9.288-34.017 8.88-34.017 8.88l-7.681-18.898 6.992-6.557 7.466-47.963 3.577-20.332 11.54-1.747z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M715.125 301.995L711.939 333.825 684.066 345.761 715.125 338.599z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3F3D56",
    d: "M564.804 196.916c8.978 2.377 16.745 8.015 21.783 15.81l2.605 4.032.131.167 45.7 13.361c1.743.51 2.756 2.32 2.279 4.07l-3.548 12.999c-.234.855-.799 1.582-1.57 2.02-.772.436-1.686.548-2.54.31l-45.713-12.767v.001l-4.592 1.734c-8.453 3.194-17.726 3.509-26.377.896l11.842-42.633z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 607.91,
    cy: 233.144,
    fill: "#575A89",
    rx: 2.789,
    ry: 5.232,
    transform: "rotate(-73.69 607.91 233.144)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 610.597,
    cy: 234.059,
    fill: "#3F3D56",
    rx: 1.919,
    ry: 1.917
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 559.002,
    cy: 218.419,
    fill: "#6C63FF",
    rx: 22.354,
    ry: 10.116,
    transform: "rotate(-72.034 559.002 218.419)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M567.204 221.121c3.672-11.315 2.674-21.86-2.159-24.155.291.037.578.1.857.19 5.314 1.722 6.534 12.637 2.723 24.38-3.811 11.744-11.209 19.867-16.524 18.145-.192-.063-.38-.138-.563-.226 5.227.666 12.056-7.21 15.666-18.334z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6369D1",
    fillOpacity: 0.4,
    d: "M565.405 196.957l-103.719-80.39c-18.34-14.317-35.941-29.558-52.732-45.663-29.566-28.16-69.702-50.673-116.432-62.66C178.989-20.878 89.048 30.759 48.14 106.58-14.37 222.443-62.278 410.456 214.897 310.377c60.618-21.887 121.978-24.214 168.503-35.743l168.466-34.707 13.539-42.97z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 254.02,
    cy: 56.112,
    fill: "#F2F2F2",
    rx: 5.575,
    ry: 5.57
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2F2F2",
    d: "M362.312 68.987L360.861 68.987 360.861 67.537 360.578 67.537 360.578 68.987 359.127 68.987 359.127 69.27 360.578 69.27 360.578 70.72 360.861 70.72 360.861 69.27 362.312 69.27zM508.05 189.939L506.599 189.939 506.599 188.489 506.315 188.489 506.315 189.939 504.864 189.939 504.864 190.222 506.315 190.222 506.315 191.672 506.599 191.672 506.599 190.222 508.05 190.222zM497.697 227.339L496.246 227.339 496.246 225.889 495.962 225.889 495.962 227.339 494.511 227.339 494.511 227.622 495.962 227.622 495.962 229.072 496.246 229.072 496.246 227.622 497.697 227.622zM52.52 259.168L51.069 259.168 51.069 257.718 50.786 257.718 50.786 259.168 49.335 259.168 49.335 259.452 50.786 259.452 50.786 260.901 51.069 260.901 51.069 259.452 52.52 259.452zM116.231 85.697L114.78 85.697 114.78 84.247 114.496 84.247 114.496 85.697 113.045 85.697 113.045 85.98 114.496 85.98 114.496 87.43 114.78 87.43 114.78 85.98 116.231 85.98zM363.905 233.705L362.454 233.705 362.454 232.255 362.171 232.255 362.171 233.705 360.72 233.705 360.72 233.988 362.171 233.988 362.171 235.438 362.454 235.438 362.454 233.988 363.905 233.988zM211.796 34.77L210.345 34.77 210.345 33.32 210.062 33.32 210.062 34.77 208.611 34.77 208.611 35.053 210.062 35.053 210.062 36.503 210.345 36.503 210.345 35.053 211.796 35.053zM118.896 159.064L117.546 159.064 117.546 157.715 117.282 157.715 117.282 159.064 115.931 159.064 115.931 159.327 117.282 159.327 117.282 160.676 117.546 160.676 117.546 159.327 118.896 159.327zM103.334 240.514L101.984 240.514 101.984 239.164 101.72 239.164 101.72 240.514 100.369 240.514 100.369 240.777 101.72 240.777 101.72 242.126 101.984 242.126 101.984 240.777 103.334 240.777zM57.671 311.897L56.321 311.897 56.321 310.548 56.057 310.548 56.057 311.897 54.707 311.897 54.707 312.161 56.057 312.161 56.057 313.51 56.321 313.51 56.321 312.161 57.671 312.161z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#3F3D56",
    fillOpacity: 0.2,
    d: "M167.905 201.142c-24.526-36.41-18.744-85.253 13.607-114.948 32.352-29.694 81.57-31.335 115.832-3.86 34.262 27.474 43.292 75.823 21.251 113.786-22.04 37.962-68.542 54.153-109.436 38.103-3.533 12.592-15.135 21.212-28.226 20.97-13.091-.241-24.367-9.283-27.431-21.996-3.064-12.714 2.856-25.89 14.403-32.055z",
    transform: "translate(-802 -781) translate(802 781)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M241.179 100.821c20.383 0 34.406 11.291 34.406 27.523 0 10.748-5.218 18.185-15.273 24.102-9.458 5.483-12.665 9.5-12.665 16.449 0 1.137-.452 2.228-1.258 3.032-.805.804-1.897 1.256-3.036 1.256h-10.42c-2.314 0-4.211-1.83-4.292-4.139l-.018-.53c-.924-11.182 2.99-18.13 12.828-23.885 9.185-5.483 13.045-8.957 13.045-15.688 0-6.732-6.523-11.672-14.622-11.672-6.155 0-11.027 2.993-13.261 7.879-1.604 3.377-5.027 5.514-8.77 5.476-7.06 0-11.724-7.499-8.422-13.732 5.223-9.859 16.244-16.071 31.758-16.071zm-14.296 93.045c0-6.243 5.218-11.183 11.632-11.183 6.469 0 11.687 4.886 11.687 11.183s-5.218 11.183-11.687 11.183c-6.468 0-11.632-4.886-11.632-11.183z",
    transform: "translate(-802 -781) translate(802 781)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyFilter);
export default __webpack_public_path__ + "static/media/empty_filter.7dcb543e178517af81ee50154302ce01.svg";
export { ForwardRef as ReactComponent };